var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-column"},[_c('Header'),_vm._v(" "),_c('MatchInfo'),_vm._v(" "),_c('MatchMenu'),_vm._v(" "),_c('MatchGame'),_vm._v(" "),_c('Footer')],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6e94f2f2","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/district/views/project/components/Game.vue
// module id = null
// module chunks = 